import http from '~/http/cryptomat';

export default ({
  state: {
    atmLimits: [],
    atms: [
      {
        address: 'г. Москва, ул. Пушкинская, д. 10',
        atmStatus: 'Active',
        BAFullnessPercent: 50,
        boxCount: 5,
        cashData: [
          {
            casePosition: 1,
            fiatCurrencyTitle: 'USD',
            fiatValue: 100,
            fiatValueCount: 10,
          },
          {
            casePosition: 2,
            fiatCurrencyTitle: 'USD',
            fiatValue: 5,
            fiatValueCount: 53,
          },
          {
            casePosition: 3,
            fiatCurrencyTitle: 'USD',
            fiatValue: 50,
            fiatValueCount: 14,
          },
        ],
        currencyCouples: [
          {
            cryptoCurrencyTitle: 'BTC',
            rate: 81.2345235,
            exchangeType: 'some',
            exchanger: 'bitqi',
            fees: [
              {
                changeLimit: 6,
                fee: 1,
                absoluteFee: 2,
              },
            ],
            fiatCurrencyTitle: 'USD',
            maxAuthEnterSum: 50000,
            maxNonAuthEnterSum: 15000,
            minEnterSum: 1000,
            priorityFeeAbsolute: 2,
            renterFeeAbsoluteBase: 1,
            renterFeeBase: 1,
            simpleFeeAbsolute: 1,
          },
        ],
        frontId: 24,
        lastUseTime: '2025-11-20T19:07:38+00:00',
        latitude: '54.26234623',
        longitude: '125.574726',
        orgName: 'Lebedev',
        renterFrontAtmId: 124,
        renterId: 1,
        supportedCryptoCurrencies: ['BTC', 'ETH', 'USDT'],
        supportedFiatCurrencies: ['USD'],
        workTime: '10:00 - 22:00',
      },
    ],
    filters: {},
    page: 1,
    pages: 0,
    limit: 10,
    itemsPerPage: 0,
  },

  mutations: {
    SET_ATM_LIMITS(state, data) { state.fees = data; },
    SET_ATMS(state, value) { state.atms = value; },
    SET_FILTERS(state, data) { state.filters = data; },
    SET_PAGE(state, value) { state.page = value; },
    SET_PAGES(state, value) { state.pages = value; },
  },

  getters: {
    requestData(state, _getters, _rootState, rootGetters) {
      const {
        filters,
        page,
      } = state;
      const itemsPerPage = rootGetters['common/itemsPerPage'];
      const formattedFilters = Object.entries(filters).reduce((acc, [key, value]) => {
        if (value || value === 0) {
          acc[key] = value;
        }
        return acc;
      }, {});
      return {
        ...formattedFilters,
        offset: (page - 1) * itemsPerPage,
        limit: itemsPerPage,
      };
    },
  },

  actions: {
    async loadAtms({ getters, commit }) {
      const response = await http.get('/api/Atms', {
        ...getters.requestData,
      });
      const { pages } = response.data;
      // commit('SET_ATMS', Atms);
      if (pages) {
        commit('SET_PAGES', pages);
      }
    },

    async loadAtmLimits({ getters, commit }) {
      const response = await http.get('/api/FeesLimits/GetAtmLimits', {
        ...getters.requestData,
      });
      const { FeeAtms } = response.data;
      commit('SET_ATM_LIMITS', FeeAtms);
    },

    async deleteAtm(__state, id) {
      await http.delete(`/api/Atms/DeleteAtm?atmId=${id}`);
    },

    async deleteCouple(__state, id) {
      await http.delete(`/api/Atms/DeleteCurrencyCouples?atmId=${id}`);
    },
  },

  namespaced: true,
});
